@if (this.suggestionsData()?.length) {
  <div class="container f-body-xs f-medium">
    @for (suggestion of suggestionsData(); track suggestion.value) {
      <button
        [class.disabled]="suggestion.disabled"
        type="button"
        (click)="
          suggestion.disabled ? null : setValue(suggestion.value);
          $event.stopPropagation()
        "
      >
        {{ suggestion.name | translate }}
      </button>
    }
  </div>
}
